import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { reduxFormPropTypes } from 'constants/propTypes';
import { shouldShowError } from 'helpers/page-utils';
import Message from 'components/Message';
import './InputError.scss';

function InputError(props) {
  const { error, className, showErrorImmediately } = props;
  const hasError = shouldShowError(props, showErrorImmediately);

  if (!hasError) return null;

  return (
    <div className={classNames('input-field-error', className)} data-cypress="form-field-error">
      <Message message={error} />
    </div>
  );
}

InputError.propTypes = {
  ...reduxFormPropTypes.field.meta,
  className: PropTypes.string,
  showErrorImmediately: PropTypes.bool,
};

InputError.defaultProps = {
  showErrorImmediately: false,
};

export default InputError;
